import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber, injectIntl, intlShape } from 'react-intl';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import { find, get, map } from 'lodash';
import { priceOptionLabel } from '../utils';

class ItemDetailsModal extends React.Component {
  render () {
    const {
      toggleModal,
      item = {},
      showModal = true,
      categories = [],
      iosWebView = false,
      whichModal = '',
      isFetchingItem = false,
      currency = 'USD',
      isVatEnabled = false
    } = this.props;
    const addtlCharges = get(item, 'additional_charges', []);
    const backgroundImg = get(item, 'image_ids[0]');
    const imgUrl = `https://img.peerspace.com/image/upload/${backgroundImg}.jpg`;
    const modalBody = (
      <div>
        { backgroundImg &&
        <div className="margin-lg-bottom" data-testing-id="add-on-photo">
          <img
            className="add-on-photo full-height full-width"
            src={imgUrl}
            alt={ this.props.intl.formatMessage({ id: 'inbox.item_details_modal.add_on_image', defaultMessage: 'Add-on image' }) }
          />
        </div>
        }

        <div data-testing-id="add-on-category" className="text-gray-600 text-small">{ item.category_display_string } / { item.subcategory_display_string }</div>

        <div data-testing-id="add-on-label" className="h4 margin-sm-top margin-sm-bottom">{ item.label }</div>

        <div>
          <FormattedMessage
            id="inbox.item_details_modal.price"
            defaultMessage="{price}{optionalLabel} {suffix}"
            values={{
              price: <FormattedNumber value={item.unit_cost} currency={currency} style='currency' />,
              optionalLabel: <FormattedMessage { ...priceOptionLabel[item.unit_cost_basis] } />,
              suffix: 1 < item.count && `● ${item.count} ${this.props.intl.formatMessage({ id: 'inbox.item_details_modal.max', defaultMessage: 'max' })}`
            }}
          />
        </div>

        <div data-testing-id="add-on-description" className="AddonsDescription text-gray-600 margin-lg-top margin-lg-bottom">{ item.description }</div>
        {
          addtlCharges.length
            ? <div data-testing-id="add-on-additional-charges">
              <p className="heavy">
                <FormattedMessage
                  id="inbox.item_details_modal.taxes_fees"
                  defaultMessage="Taxes & Fees"
                />
              </p>
              {
                map(addtlCharges, (charge) => {
                  if (charge.charge_type === "included_vat") {
                    return null;
                  }
                  return (
                    <div className="flex margin-md-bottom space-between" key={charge.charge_id} data-testing-id="additional-charge">
                      <div data-testing-id={`additional-charge-label-${charge.charge_id}`} className="text-gray-600">{charge.label}</div>
                      <div data-testing-id={`additional-charge-cost-${charge.charge_id}`} className="text-gray-600 text-right">
                        {
                          '%' === charge.charge_unit
                            ? charge.cost_display_string
                            : <FormattedNumber value={charge.amount} currency={currency} style='currency' />
                        }
                      </div>
                    </div>
                  );
                })
              }
            </div> : null
        }
      </div>)

    return (
      isFetchingItem ? null :
      <div>
        {
          iosWebView && (`viewAddOnDetailsModal-${item._id}` === whichModal) ?
            <div className="item-details-ios ItemDetailsModal">
              <div className="pull-right ico ico-sm icon-close-sidebar margin-lg-bottom" onClick={() => { toggleModal(''); }} />

              { modalBody }
              <div className="margin-lg-top text-xs-center">
                <CTAButton
                  buttonText={ this.props.intl.formatMessage({ id: 'inbox.item_details_modal.close', defaultMessage: 'Close' }) }
                  classNameString="btn btn-gray-outline full-width"
                  onClickAction={ () => { toggleModal(''); } }
                  isDisabled={ false }
                />
              </div>
            </div>
            : <BootstrapModal
              onClose={toggleModal}
              showModal={showModal}
              modalSize="sm-size"
              modalClass="ItemDetailsModal"
              body={ modalBody }
              footer={
                <CTAButton
                  buttonText={ this.props.intl.formatMessage({ id: 'inbox.item_details_modal.close_button', defaultMessage: 'Close' }) }
                  classNameString="btn btn-gray-outline full-width"
                  onClickAction={ () => { toggleModal(''); } }
                  isDisabled={ false }
                  attributes={{
                    'data-testing-id': 'close-item-details-modal-btn'
                  }}
                />
              }
            />
        }
      </div>
    );
  }
}

ItemDetailsModal.propTypes = {
  toggleModal: PropTypes.func,
  currency: PropTypes.string,
  itemDescription: PropTypes.string,
  label: PropTypes.string,
  price: PropTypes.number,
  unitCostBasis: PropTypes.string,
  itemId: PropTypes.string,
  intl: intlShape
};

exports.ItemDetailsModal = injectIntl(ItemDetailsModal);
